import { createContext } from "react";

export const InterceptorContext = createContext({});
